let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8RnVw")).then(() => parcelRequire('ho2si'));